import { useRef, useEffect, useCallback } from 'react';

export const useDragDetection = (dragThreshold = 5) => {
  const isDraggingRef = useRef(false);
  const startPositionRef = useRef({ x: 0, y: 0 });

  const handleMouseMove = useCallback((e) => {
    const distance = Math.sqrt(
      Math.pow(e.clientX - startPositionRef.current.x, 2)
      + Math.pow(e.clientY - startPositionRef.current.y, 2)
    );
    if (distance > dragThreshold) {
      isDraggingRef.current = true;
    }
  }, [dragThreshold]);

  const handleMouseUp = useCallback(() => {
    window.removeEventListener('mousemove', handleMouseMove);
    window.removeEventListener('mouseup', handleMouseUp);
    setTimeout(() => {
      isDraggingRef.current = false;
    }, 0);
  }, [handleMouseMove]);

  const handleMouseDown = useCallback((e) => {
    startPositionRef.current = { x: e.clientX, y: e.clientY };
    isDraggingRef.current = false;
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  }, [handleMouseMove, handleMouseUp]);

  useEffect(() => {
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [handleMouseMove, handleMouseUp]);

  const isDragging = () => isDraggingRef.current;

  return { handleMouseDown, isDragging };
};
